import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-neutral-background flex items-center justify-center">
      <div className="bg-white rounded-sm p-12 shadow-lg border border-slate-200 text-center max-w-md">
        <XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" />
        <h2 className="font-manrope font-bold text-2xl text-primary mb-3" data-testid="payment-cancelled">
          Payment Cancelled
        </h2>
        <p className="text-slate-600 font-public-sans mb-6">
          Your payment was cancelled. No charges have been made to your account.
        </p>
        <div className="flex gap-4 justify-center">
          <Button
            onClick={() => navigate('/')}
            variant="outline"
            className="border-2 border-slate-300 text-primary hover:bg-slate-50 rounded-sm px-8 py-3"
          >
            Go to Home
          </Button>
          <Button
            onClick={() => navigate(-2)}
            className="bg-primary text-white hover:bg-primary-900 rounded-sm px-8 py-3"
            data-testid="try-again-button"
          >
            Try Again
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PaymentCancel;